import { useNavigate } from "react-router-dom";
import { AnnouncementComposer } from "../../components/admin/announcements/AnnouncementComposer";
import { AnnouncementList, LIST_HEADERS } from "../../components/admin/announcements/AnnouncementList";
import own from "../../components/admin/announcements/Announcements.module.css";
import { AdminTableSkeleton } from "../../components/admin/AdminTableSkeleton";
import { Toast, useToast } from "../../components/Toast";
import { useAdminAnnouncements } from "../../hooks/useAdminAnnouncements";
import { useAdminClaws } from "../../hooks/useAdminClaws";
import styles from "../AdminInstances.module.css";
import { AdminPageIntro } from "../../components/admin/AdminPageIntro";

// Write an announcement and check where it would land before anyone gets it.
// Creating one only starts a dry run; sending is an explicit step on the detail page.
export const AdminAnnouncements = (): JSX.Element => {
  const navigate = useNavigate();
  const { toast, showToast, dismissToast } = useToast();
  const { status, announcements, error, isFetching, create } = useAdminAnnouncements();
  const { claws } = useAdminClaws();

  const handleCreate = async (body: string, tenantIds: ReadonlyArray<string> | null): Promise<boolean> => {
    const result = await create(body, tenantIds);
    if (!result.ok) {
      showToast(`Could not create the announcement: ${result.message}`, "error");
      return false;
    }
    navigate(result.value.announcement.id);
    return true;
  };

  return (
    <div className={styles.page}>
      <AdminPageIntro title="Announcements">
        Message every customer on their usual channel, or their dashboard chat if they have none. Their agent is told what was sent.
      </AdminPageIntro>

      <AnnouncementComposer claws={claws} onCreate={handleCreate} />

      <section className={styles.listSection}>
        {status === "loading" && (
          <AdminTableSkeleton headers={LIST_HEADERS} tableClassName={`${styles.table ?? ""} ${own.compactTable ?? ""}`} />
        )}
        {status === "error" && <div className={styles.empty}>{error ?? "Failed to load announcements."}</div>}
        {status === "ready" && announcements.length === 0 && <div className={styles.empty}>No announcements yet.</div>}
        {status === "ready" && announcements.length > 0 && (
          <AnnouncementList announcements={announcements} isFetching={isFetching} />
        )}
      </section>

      <Toast toast={toast} onDismiss={dismissToast} />
    </div>
  );
};
